export default __webpack_public_path__ + "static/media/robinBlock.4220c059.jpeg";